module.exports = "./img/696137710e8b1c6dac00a41d560970c1.jpg";